import { all } from 'redux-saga/effects';
import login from './LoginSaga/loginSaga';
import viewAdminProfile from './ViewProfileSaga/ViewProfileSaga';
import forgot from './ForgotSaga/forgotSaga';
import updateProfile from './UpdateProfileSaga/updateProfileSaga';
import logout from './LogoutSaga/logoutSaga';
import viewPrograms from './MasterDataSaga/ProgramsSaga/ProgramSaga';
import viewAssessments from './MasterDataSaga/AssessmentSaga/AssessmentSaga';
import viewAssessmentQuestion from './MasterDataSaga/AssessmentSaga/ViewAssessmentSaga';
import guestUser from './UserManagementSaga/GuestUserSaga/GuestUserSaga';
import viewTeamMembers from './UserManagementSaga/TeamMemberSaga/TeamMemberSaga';
import userRole from './UserManagementSaga/UserRoleSaga/UserRoleSaga';
import accessManagement from './UserManagementSaga/AccessManagementSaga/AccessManagementSaga';
import recipeCollection from './MasterDataSaga/RecipeCollectionSaga/RecipeCollectionSaga';
import videoPodcast from './ContentManagementSaga/videoPodcastSaga/videoPodcastSaga';
import contentCategory from './MasterDataSaga/ContentCategorySaga/ContentCategorySaga';
import Events from './EventsSaga/EventsSaga';
import viewActivities from './MasterDataSaga/ActivitySaga/ActivitySaga';
import viewTestimonials from './ReportSaga/TestimonialSaga/TestimonialSaga';
import programFeedback from './ReportSaga/ProgramFeedbackSaga/ProgramFeedbackSaga';
import guestDinacharya from './ReportSaga/GuestDinacharyaSaga/GuestDinacharyaSaga';
import UserManualSaga from './UserManualSaga/UserManualSaga';
import qmsDashboard from './ReportSaga/QMSScoreboardSaga/QMSScoreboardSaga';
import guestComments from './ReportSaga/GuestCommentsSaga/GuestCommentsSaga';
import consultantRatings from './ReportSaga/ConsultantRatingsSaga/ConsultantRatingsSaga';
import queryReport from './AnalyticalReportSaga/QueryReportSaga';
import announcementSaga from './ContentManagementSaga/AnnouncementsSaga';
import qmsFeedbackDetailsReportSaga from './ReportSaga/QMSFeedbackDetailsReportSaga/QMSFeedbackDetailsReportSaga';
import RecommendationsSaga from './ReportSaga/TherapistNotesSaga';
import { deleteRequest } from '../reducers/UserManagementReducer/DeleteRequestReducer';
import deleteRequestSaga from './UserManagementSaga/DeleteRequestSaga/DeleteRequestSaga';

export default function* SagaMain() {
  yield all([
    login(),
    viewAdminProfile(),
    forgot(),
    updateProfile(),
    logout(),
    viewPrograms(),
    viewAssessments(),
    viewAssessmentQuestion(),
    guestUser(),
    viewTeamMembers(),
    userRole(),
    accessManagement(),
    recipeCollection(),
    videoPodcast(),
    contentCategory(),
    Events(),
    viewActivities(),
    viewTestimonials(),
    programFeedback(),
    guestDinacharya(),
    UserManualSaga(),
    qmsDashboard(),
    guestComments(),
    consultantRatings(),
    queryReport(),
    announcementSaga(),
    qmsFeedbackDetailsReportSaga(),
    RecommendationsSaga(),
    deleteRequestSaga()
  ])
}